import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../store";
import { closeDialog } from "../store/dialogSlice";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const ConfirmDialog: React.FC = () => {
  const dispatch = useDispatch();
  const activeDialog = useSelector(
    (state: RootState) => state.dialog.activeDialog
  );

  const handleClose = () => {
    dispatch(closeDialog());
  };

  return (
    <Dialog open={activeDialog === "confirm"} onClose={handleClose}>
      <DialogTitle>Bekräftelse</DialogTitle>
      <DialogContent>
        <DialogContentText>
          En länk har skickats till din e-postadress. Kontrollera din inkorg för
          att logga in.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Stäng
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
